module.exports = __webpack_public_path__ + "static/img/Jack-Todd.dc76147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Todd.jpg
// module id = pE3f
// module chunks = 0